import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';  // ✅ Imported Link

const AdminDashboard = () => {
  // Sujay 16/6/2025 making changes in the Dashborad of the HOST
  const PlatformID = localStorage.getItem("platformID");
  const [totalAuthor, setTotalAuthor] = useState();
  const [totalReviewer, setTotalReviewer] = useState();
  const [totalPaper, setTotalPaper] = useState();
  const [acceptedPaper, setAcceptedPaper] = useState();
  const [pendingPaper, setPendingPaper] = useState();
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/api/admin/auth-rev-paper/${PlatformID}`); // Adjust endpoint as needed
        setTotalAuthor(res.data.authorCount);
        setTotalReviewer(res.data.reviewerCount);
        setTotalPaper(res.data.paperCount);
        setAcceptedPaper(res.data.acceptedPaper);
        setPendingPaper(res.data.pendingPaper);
      } catch (err) {
        console.error('Error', err);
      }
    }
    fetchData();
    
  }, [])

  return (
    <div>

      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>{/* /.col */}
          </div>{/* /.row */}
        </div>{/* /.container-fluid */}
      </div>
      {/* /.content-header */}
      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          {/* Small boxes (Stat box) */}
          <div className="row">
            
            <div className="col-lg-3 col-6">
              {/* small box */}
              <Link to="/admin/authors-list" state={{defaultFilter:'approved'}} className="text-decoration-none">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{totalAuthor}</h3>
                    <p>Total Approved Authors</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-person-add" />
                  </div>
                </div>
              </Link>
            </div>
            {/* ./col */}
            
            <div className="col-lg-3 col-6">
              {/* small box */}
              <Link to="/admin/reviewer-list" state={{defaultFilter:'approved'}} className="text-decoration-none">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{totalReviewer}</h3>
                    <p>Total Approved Reviewer</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-person-add" />
                  </div>
                </div>
              </Link>
            </div>
            {/* ./col */}
            
            <div className="col-lg-3 col-6">
              {/* small box */}
              <Link to="/admin/submission-list" className="text-decoration-none">
                <div className="small-box bg-secondary">
                  <div className="inner">
                    <h3>{totalPaper}</h3>
                    <p>Total Paper submissions</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag" />
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="col-lg-3 col-6">
              {/* small box */}
              <Link to="/admin/submission-list" state={{defaultFilter:'accepted'}} className="text-decoration-none">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{acceptedPaper}</h3>
                    <p>Final Accepted Papers</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag" />
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="col-lg-3 col-6">
              {/* small box */}
              {/* <Link to="/host/submission-list" state={{defaultFilter:'pending'}} className="text-decoration-none">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h3>{pendingPaper}</h3>
                    <p>Total Pending submissions</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag" />
                  </div>
                </div>
              </Link> */}
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
